import React, { useContext } from 'react';
import { Box, Optional } from '@honda-canada/design-system-react';

import BottomElementContext from '../service/BottomElementProvider/BottomElementContext';
import FooterContext from '../service/FooterContext';
import GeoLocator from '../shared/GeoLocator';
import MenuBottom from './MenuBottom';
import MenuMain from './MenuMain';
import MenuSecondary from './MenuSecondary';
import MenuTop from './MenuTop';
import themeStyles from '../Footer.styles';

const MobileContainer = themeStyles.apply(Box, 'MobileContainer');
const SecondaryMenuContainer = themeStyles.apply(Box, 'SecondaryMenuContainer');

const MobileFooter = () => {
  const {
    mobileLocationAtSecondary,
    mobileLocationAtSecondaryUnder,
    mobileSocialAtSecondary,
    showGeoLocator,
    styles,
    footerMobileContainerPaddingX,
    footerMobileContainerPaddingTop,
    footerSecondaryMenuContainerPaddingX,
  } = useContext(FooterContext);
  const { isHidden } = useContext(BottomElementContext);

  return (
    <MobileContainer
      $styles={styles.mobileContainer}
      isHidden={isHidden}
      paddingX={footerMobileContainerPaddingX}
      paddingTop={footerMobileContainerPaddingTop}
    >
      <MenuTop />
      <MenuMain />
      <SecondaryMenuContainer paddingX={footerSecondaryMenuContainerPaddingX}>
        <Optional when={mobileSocialAtSecondary || mobileLocationAtSecondary || mobileLocationAtSecondaryUnder}>
          <Optional when={mobileLocationAtSecondaryUnder && showGeoLocator}>
            <GeoLocator padding />
          </Optional>
          <MenuSecondary />
        </Optional>
        <MenuBottom />
      </SecondaryMenuContainer>
    </MobileContainer>
  );
};

export default MobileFooter;
